var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataModel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.24 8.33C21.12 6.73 17.43 6 14 6C10.57 6 6.88 6.73 6.76 8.33C6.75 8.35 6.75 8.38 6.75 8.41V19.59C6.75 21.25 10.51 22 14 22C17.49 22 21.25 21.25 21.25 19.59V8.41C21.25 8.38 21.25 8.35 21.24 8.33ZM14 7C18.12 7 20.25 7.99 20.25 8.41C20.25 8.83 18.12 9.82 14 9.82C9.88 9.82 7.75 8.83 7.75 8.41C7.75 7.99 9.88 7 14 7ZM7.75 9.71C9.1 10.47 11.61 10.82 14 10.82C16.39 10.82 18.9 10.47 20.25 9.71V14.18C20.25 14.6 18.12 15.59 14 15.59C9.88 15.59 7.75 14.6 7.75 14.18V9.71ZM14 21C9.88 21 7.75 20.01 7.75 19.59V15.48C9.1 16.23 11.61 16.59 14 16.59C16.39 16.59 18.9 16.23 20.25 15.48V19.59C20.25 20.01 18.12 21 14 21Z",
    fill: "#616160"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.75 8.32999C6.75 8.57999 6.75 8.95499 6.75 9.32999V8.32999H7.75Z",
    fill: "#616160"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2422 8.32999V9.32999C22.2422 8.95499 22.2422 8.57999 21.2422 8.32999H22.2422Z",
    fill: "#616160"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1791 12.83C11.1791 13.42 10.6991 13.91 10.1091 13.91C9.51906 13.91 9.03906 13.42 9.03906 12.83C9.03906 12.24 9.51906 11.76 10.1091 11.76C10.6991 11.76 11.1791 12.24 11.1791 12.83Z",
    fill: "#616160"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1791 18.4C11.1791 18.99 10.6991 19.4699 10.1091 19.4699C9.51906 19.4699 9.03906 18.9899 9.03906 18.4C9.03906 17.8 9.51906 17.32 10.1091 17.32C10.6991 17.32 11.1791 17.8 11.1791 18.4Z",
    fill: "#616160"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataModel);
export default __webpack_public_path__ + "static/media/DataModel.b984202ae0be34772603e73d8a16d7af.svg";
export { ForwardRef as ReactComponent };